import { isAllHtmlElements } from "./is-all-html-elements";

/**
 * Synchronize widths of elements
 * @param {Array<HTMLElement|null>} elements - Elements to synchronize
 */
export const syncElementWidths = (elements: Array<HTMLElement | null> | NodeList) => {
  const els = elements instanceof NodeList ? Array.from(elements) : elements;

  if (els.length === 0 || !isAllHtmlElements(els)) {
    return;
  }

  const widthSource = els.sort((a, b) => {
    const widthA = getComputedStyle(a).getPropertyValue("width").replace("px", "");
    const widthB = getComputedStyle(b).getPropertyValue("width").replace("px", "");
    return parseInt(widthB) - parseInt(widthA);
  })[0];

  const syncedWidth = getComputedStyle(widthSource).getPropertyValue("width");

  for (const el of els) {
    if (getComputedStyle(el).getPropertyValue("width") !== syncedWidth) {
      el.style["width"] = syncedWidth;
    }
  }
};
